export default __webpack_public_path__ + "static/logo-e399e845e2c35e85c244d9c39e8cd1d3.png";